<template>
  <NuxtLink :class="className" class="block h-full group" :to="linkTo">
    <div
      class="items-center h-full w-full min-h-0 overflow-hidden border p-[5px] gap-2.5 rounded-[10px] flex"
      :class="resolvedCardClass"
    >
      <div
        v-if="img || src"
        class="insight-widget-image h-full aspect-square shrink-0 self-stretch overflow-hidden rounded-md"
      >
        <AtomImage
          class="insight-widget-image__img !h-full !w-full !transition-none object-cover"
          :src="src"
          :strapi-image-object="img"
        />
      </div>
      <div class="flex h-full w-full flex-col">
        <div class="grow md:mb-1.5">
          <h3 class="text-base line-clamp-3 leading-[1.2]">
            {{ title }}
          </h3>
        </div>
        <button
          class="w-5 shrink-0 h-5 ml-auto grid place-content-center bg-white duration-300 rounded-full"
          :class="resolvedButtonClass"
        >
          <span class="inline-flex" :class="{ 'rotate-90': arrowDirection === 'down' }">
            <Arrow :class="resolvedArrowClass" />
          </span>
        </button>
      </div>
    </div>
  </NuxtLink>
</template>

<script>
import Arrow from '../atoms/arrow.vue'
import AtomImage from '../atoms/AtomImage.vue'

const DEFAULT_CARD_CLASS = 'border-white bg-white hover:border-gray-600 hover:bg-gray-600'
const DEFAULT_BUTTON_CLASS = 'group-hover:bg-gray-100'
const DEFAULT_ARROW_CLASS = 'group-hover:[&_*]:stroke-white'

export default {
  name: 'InsightWidget',
  components: {
    Arrow,
    AtomImage,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    img: {
      type: Object,
      default: null,
    },
    src: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    to: {
      type: String,
      default: '',
    },
    cardClass: {
      type: String,
      default: '',
    },
    buttonClass: {
      type: String,
      default: '',
    },
    arrowClass: {
      type: String,
      default: '',
    },
    arrowDirection: {
      type: String,
      default: 'right',
      validator: value => ['right', 'down'].includes(value),
    },
  },
  computed: {
    linkTo() {
      if (this.to) return this.to
      return `/insider/${this.id}`
    },
    resolvedCardClass() {
      return this.cardClass || DEFAULT_CARD_CLASS
    },
    resolvedButtonClass() {
      return this.buttonClass || DEFAULT_BUTTON_CLASS
    },
    resolvedArrowClass() {
      return this.arrowClass || DEFAULT_ARROW_CLASS
    },
  },
}
</script>

<style lang="postcss" scoped>
.insight-widget-image {
  max-height: 100%;
}

.insight-widget-image :deep(img) {
  @apply block h-full w-full max-h-full object-cover;
}
</style>
